import { Navigate, createFileRoute } from "@tanstack/react-router";

import { DashboardPlaceholder } from "../tools/dashboards/DashboardPlaceholder";
import { DASHBOARD_ARTIFACTS_SEGMENT, getDashboardBySlug } from "../tools/dashboards/catalog";

function DashboardByIdRoute() {
  const { dashboardId } = Route.useParams();

  // Prefer the dedicated live route if ranking ever hits the catch-all.
  if (dashboardId === "attrition") {
    return <Navigate to="/dashboards/attrition" replace />;
  }
  if (dashboardId === "eng-velocity") {
    return <Navigate to="/dashboards/eng-velocity" replace />;
  }
  if (dashboardId === "product-priorities") {
    return <Navigate to="/dashboards/product-priorities" replace />;
  }
  if (dashboardId === "experiments") {
    return <Navigate to="/dashboards/cn-call-review" replace />;
  }
  if (dashboardId === "cn-call-review") {
    return <Navigate to="/dashboards/cn-call-review" replace />;
  }
  if (dashboardId === "account-management") {
    return <Navigate to="/dashboards/account-management" replace />;
  }
  if (dashboardId === "sales") {
    return <Navigate to="/dashboards/sales" replace />;
  }
  if (dashboardId === "enrollment") {
    return <Navigate to="/dashboards/enrollment" replace />;
  }
  if (dashboardId === "care-navigation") {
    return <Navigate to="/dashboards/care-navigation" replace />;
  }
  if (dashboardId === "cal-killer") {
    return <Navigate to="/dashboards/cal-killer" replace />;
  }
  if (dashboardId === "switchboard") {
    return <Navigate to="/dashboards/switchboard" replace />;
  }
  if (dashboardId === "website-traffic") {
    return <Navigate to="/dashboards/website-traffic" replace />;
  }
  if (dashboardId === "revenue") {
    return <Navigate to="/dashboards/revenue" replace />;
  }
  if (dashboardId === "inbound-calls") {
    return <Navigate to="/dashboards/inbound-calls" replace />;
  }
  if (dashboardId === "dcmp-billing") {
    return <Navigate to="/dashboards/dcmp-billing" replace />;
  }
  if (dashboardId === "reengagement-emails") {
    return <Navigate to="/dashboards/reengagement-emails" replace />;
  }
  if (dashboardId === "retell-calls") {
    return <Navigate to="/dashboards/retell-calls" replace />;
  }
  if (dashboardId === "data-dictionary") {
    return <Navigate to="/dashboards/data-dictionary" replace />;
  }
  if (dashboardId === "ask") {
    return <Navigate to="/dashboards" replace />;
  }

  if (dashboardId === DASHBOARD_ARTIFACTS_SEGMENT) {
    return <Navigate to="/dashboards" replace />;
  }

  const entry = getDashboardBySlug(dashboardId);
  return <DashboardPlaceholder entry={entry} slug={dashboardId} />;
}

export const Route = createFileRoute("/_app/dashboards/$dashboardId")({
  component: DashboardByIdRoute,
});
